
export const MODULE_NAME = 'lk-reg-meh'

export const LK_REG_MEH_ROUTES = {
  LAYOUT: MODULE_NAME,
  LIST: `${MODULE_NAME}.list`,
  VIEW: `${MODULE_NAME}.view`,
} as const
